import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { mapActions, mapState } from 'vuex'
import { queryStatus, init, getSystemList } from '@/api/login'
import { resetRouter } from '@/router'
import { startMicroApp } from '@/utils/microTools'

const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      sidebarOpened: state => state.app.sidebar
    })
  },
  methods: {
    isTopMenu () {
      return this.layoutMode === 'topmenu'
    },
    isSideMenu () {
      return !this.isTopMenu()
    }
  }
}

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile () {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop () {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet () {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
}

const AppDeviceEnquire = {
  mounted () {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          $store.dispatch('setSidebar', true)
          break
        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          $store.dispatch('setSidebar', false)
          break
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          $store.dispatch('setSidebar', true)
          break
      }
    })
  }
}

const login = {
  methods: {
    ...mapActions(['Login', 'Logout']),
    judgeStatus() {
      return new Promise((resolve, reject) => {
        queryStatus()
          .then((res) => {
            const data = res.data
            resolve(Boolean(res.code === '0' && data && data.success))
          })
          .catch((err) => {
            reject(err)
            this.Logout()
          })
      })
    },
    successLogin(user) {
      const { mobile } = user
      // 清除其他当前已登录的角色信息（用于permission路由判断）
      this.$store.commit('CLEAR_ACCOUNT_PROXY', [])
      this.$store.commit('SET_SYSTEM_LIST', [])
      if (this.$cookie.get('finalLevel')) this.$cookie.remove('finalLevel')
      this.$store.commit('SET_ROLES', [])
      resetRouter()
      this.initTenantData().then((res) => {
        if (res) {
          getSystemList()
            .then((res) => {
              this.$store.commit('SET_SYSTEM_LIST', res.data)
              const sys = res.data ? res.data.find((item) => item.defaultAccess === 1) : undefined
              // 判断是否有默认访问系统
              if (sys !== undefined) {
                startMicroApp(sys, true)
              } else {
                // 无默认系统跳转首页
                const { $ls, name, $store, $router } = this
                const subApp = $ls.get(`sub-app_${mobile}`)
                const currentApp = subApp?.[name]
                if (currentApp && res.data?.some((item) => item.code === currentApp.code)) {
                  startMicroApp(currentApp, true)
                } else {
                  $store.commit('SET_FIRST_LOGIN', true)
                  $router.push({ path: '/' })
                }
              }
            })
            .catch((err) => {
              console.error(err)
            })
        }
      }).catch(console.log)
    },
    initTenantData() {
      this.$loading.show({ tip: '租户数据设置中...' })
      return new Promise((resolve, reject) => {
        this.judgeStatus()
          .then((status) => {
            if (!status) {
              init().then((res) => {
                const { data } = res
                if (data && data.success) {
                  resolve(true)
                } else {
                  const msg = data.msg || '初始化租户信息失败'
                  this.$message.error(msg)
                  reject(msg)
                }
              })
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
            this.Logout()
          })
      })
    }
  }
}

export { mixin, AppDeviceEnquire, mixinDevice, login }
